// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2qDFi","inner":"Form_inner__2kWF6","range":"Form_range__1KBTS","name":"Form_name__8MlhY","actions":"Form_actions__1edyY"};